import a from "react";
const u = ({ text: e, type: s, disabled: t }) => {
  const c = s === "success" ? `bg-success-05 ${t ? "text-[#A3BFAB]" : "text-success-80"}` : `bg-neutrals-10 ${t ? "text-neutrals-40" : "text-neutrals-90"}`;
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      className: `flex h-fit rounded-md px-1 py-0.5 text-xs font-medium ${c}`
    },
    e
  );
};
export {
  u as Tag
};
